import { types } from "../actions";

const initialState = {
  roiData: [],
  roiResponse:[],
  statisticData: [],
  updateResponse: [],
  deleteRes: [],
  rulesByDeviceId: [],
  rulesSuccess: [],
  taggedRoiResponse:[],
  
  taggedAddTagRoiResponse:[],
  fetched:false,
  roiError: [],
  cvAppRoiLoading: false,
  roiListWithCvappsLoadingStatus: "NotLoaded"
};

const polygonRoiReducer = (state = initialState, action) => {
  switch (action.type) {

    case types.DEVICES_SELECTED_DATA: {
      return {
          ...state,
          devicesSelected: action.devicesSelected
      }
    }
    case types.SET_ROI_POLYGON: {
      // console.log(action, state,">>>> New", Object.keys(state.roiData).length);
        return {
            ...state,
            //roiData: Object.keys(state.roiData).length ? [...state['roiData'], action.roiData] : action.roiData
            roiData: action.roiData
          }
    }
    case types.ROI_FAIL_RESPONSE: {
      return {
        ...state,
        roiError: action.roiError
    }
    }
    case types.ROI_SUCCESS_RESPONSE: {
      return {
          ...state,
          roiResponse: action.roiResponse
      }
  }
  case types.TAG_ROI_SUCCESS_RESPONSE: {
    return {
        ...state,
        taggedRoiResponse: action.taggedRoiResponse
    }
}
case types.ROI_ADD_TAG_SUCCESS_RESPONSE: {
  return {
      ...state,
      taggedAddTagRoiResponse: action.roiResponse
  }
}

  case types.ROI_UPDATE_SUCCESS_RESPONSE: {
    return {
        ...state,
        roiResponse: action.roiResponse
       // updateResponse: action.roiResponse
    }
  }
  case types.ROI_DELETE_SUCCESS_RESPONSE: {
    return {
        ...state,
        deleteRes: action.roiResponse === "" ? "Success" : action.roiResponse
    }
  }
  case types.RESET_ROI: {
    return {
      ...state,
      roiData: [],
      roiResponse:[],
      statisticData: [],
      updateResponse: [],
      deleteRes: [],
      rulesByDeviceId: [],
      rulesSuccess: [],
      taggedRoiResponse:[],
      taggedAddTagRoiResponse:[],
      roiError: [],
      rulesData: [],
    }
  }

  case types.SET_STATISTICS: {
    return {
      ...state,
      statisticData: action.statisticData
    }
  }
  case types.FETCH_RULES_BY_DEVICE_ID_REQUEST:
      return {
        ...state,
        payload: action.payload,
        fetched: true,
      };
  case types.FETCH_RULES_BY_DEVICE_ID_SUCCESS:
      return {
        ...state,
        rulesByDeviceId: action.response,
      };
  case types.FETCH_RULES_SUCCESS:
      return {
        ...state,
        rulesData: action.response,
      };
  case types.RULE_SUCCESS_RESPONSE:
        return {
          ...state,
          rulesSuccess: action.ruleResponse
        };
  case types.SET_ROI_LIST_WITH_CVAPPS: {
        return {
            ...state,
            roiListWithCvapps: action.roiList
        }
        };
  case types.CV_APP_ROI_LOADING: {
        return {
            ...state,
            cvAppRoiLoading: action.payload
        }
        };
  case types.SET_ROI_LIST_WITH_CVAPPS_LOADING_STATUS: {
        return {
            ...state,
            roiListWithCvappsLoadingStatus: action.payload
        }
        };

    default:
      return state;
  }
};
export default polygonRoiReducer;
